






























































































































	import { Component, Vue } from 'vue-property-decorator'
	import HeadLable from '@/components/HeadLable/index.vue'
	import ImageUpload from '@/components/ImgUpload/index.vue'

  import {
    addOrder,
    uploadFile,
    queryResvDetailById,
    updateOrder,
    getCompanyByCompanyName,
    companyFuzzyQuery

  } from '@/api/order'  //把接口方法导入
import { Message } from 'element-ui'

	@Component({
		name: 'addShop',
		components: {
			HeadLable,
			ImageUpload

		}
	})
	export default class extends Vue {
		private title = '添加预约人信息'
		private actionType = 'add'
		private imageUrl = ''
		private dialogImageUrl = ''
    private dialogVisible = false
		private ruleForm = {
			username: '',
			phoneNum: '',
			gender: '男',
			certificateType: '',
			certificateNumber: '',
			photo: '',
			companyCode: '',
			companyQualification: '',
			companyName: '',
			companyLicense: '',
			jobType: ''
		}

    private videoWidth= 234
    private  videoHeight = 288
		private imgSrc = ""
		private thisCancas = null
		private thisContext = null
		private thisVideo = null
    private loadingbut = true
    private options = []

    private companyQualificationOptions= [
      { label: "营业执照", value: 1 },
      { label: "统一社会信用代码证书", value: 2 },
      { label: "卫生许可证", value: 3 },
      { label: "食品安全许可证", value: 4 },
      { label: "食品经营许可证", value: 5 },
      { label: "其他法定有效证件", value: 6 },
    ]
    private certificateTypeOptions: any[] = [
      { label: "居民身份证", value: 1 },
      { label: "护照", value: 3 },
      { label: "港澳居民来往内地通行证", value: 6 },
      { label: "台湾居民来往内地通行证", value: 7 },
      { label: "港澳台居民居住证", value: 99 },
    ];

    private jobTypeOptions: any[] = [
      { label: "食品", value: 1 },
      { label: "乳制品", value: 2 },
      { label: "医药", value: 3 },
      { label: "美容", value: 4 },
      { label: "服务", value: 5 },
      { label: "饮用水", value: 6 },
      { label: "消毒产品生产", value: 7 },
      { label: "其他", value: 99 },
    ];


// 计算属性用于回显企业资质类型
    get companyQualificationDisplay() {
      const selected = this.companyQualificationOptions.find(
        option => option.value === this.ruleForm.companyQualification
      );
      return selected ? selected.label : '';
    }    get jobTypeOptionsDisplay() {
      const selected = this.jobTypeOptions.find(
        option => option.value === this.ruleForm.jobType
      );
      return selected ? selected.label : '';
    }    get certificateTypeOptionsDisplay() {
      const selected = this.certificateTypeOptions.find(
        option => option.value === this.ruleForm.certificateType
      );
      return selected ? selected.label : '';
    }
    imageChange(value: any) {
			this.ruleForm.companyLicense = value
		}
    photoChange(value: any) {
			this.ruleForm.photo = value
		}
		mounted() {
			this.getCompetence();
		}
    showImage(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    }
		getCompetence() {
		var _this = this;
		this.thisCancas = document.getElementById("canvasCamera");
		this.thisContext = this.thisCancas.getContext("2d");
		this.thisVideo = document.getElementById("videoCamera");
		if (navigator.mediaDevices.getUserMedia === undefined) {
			navigator.mediaDevices.getUserMedia = function (constraints) {
			// 首先获取现存的getUserMedia(如果存在)
        var getUserMedia = (navigator as any).webkitGetUserMedia || (navigator as any).mozGetUserMedia || navigator.getUserMedia;
			// 有些浏览器不支持，会返回错误信息
			// 保持接口一致
			if (!getUserMedia) {
				return Promise.reject(
				new Error("getUserMedia is not implemented in this browser")
				);
			}
			// 否则，使用Promise将调用包装到旧的navigator.getUserMedia
			return new Promise(function (resolve, reject) {
				getUserMedia.call(navigator, constraints, resolve, reject);
			});
			};
		}
		var constraints = {
			audio: false,
			video: {
			width: this.videoWidth,
			height: this.videoHeight,
			transform: "scaleX(-1)",
			},
		};
		navigator.mediaDevices
			.getUserMedia(constraints)
			.then(function (stream) {
			// 旧的浏览器可能没有srcObject
			if ("srcObject" in _this.thisVideo) {
				_this.thisVideo.srcObject = stream;
			} else {
				// 避免在新的浏览器中使用它，因为它正在被弃用。
				_this.thisVideo.src = window.URL.createObjectURL(stream);
			}
			_this.thisVideo.onloadedmetadata = function (e) {
				_this.thisVideo.play();
			};
			})
			.catch((err) => {
			console.log(err);
			});
		}
		//  绘制图片（拍照功能）
		setImage() {
			var _this = this;
			// 点击，canvas画图
			_this.thisContext.drawImage(
				_this.thisVideo,
				0,
				0,
				_this.videoWidth,
				_this.videoHeight
			);
			// 获取图片base64链接
			var image = this.thisCancas.toDataURL("image/png");
			_this.imgSrc = image;

		}
		// base64转文件
		dataURLtoFile(dataurl, filename) {
		var arr = dataurl.split(",");
		var mime = arr[0].match(/:(.*?);/)[1];
		var bstr = atob(arr[1]);
		var n = bstr.length;
		var u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new File([u8arr], filename, { type: mime });
		}
		// 上传图片
		uploadImg() {
		var _this = this;
		var file = this.dataURLtoFile(this.imgSrc, "test.png");
		var formData = new FormData();
		formData.append("file", file);
		_this.loadingbut = true;
		uploadFile(file)
		.then(function (response) {
			_this.loadingbut = false;
			if (response.data.code===1) {
				_this.ruleForm.photo = response.data.data;
				_this.$message.success("上传成功");
			} else {
				_this.$message.error(response.data.msg || "上传失败");
			}
			})
		.catch(function (error) {
			_this.loadingbut = false;
			_this.$message.error("上传过程中发生错误");
			});
		}
		// 关闭摄像头
		stopNavigator() {
		this.thisVideo.srcObject.getTracks()[0].stop();
		}



		private isCellPhone(val : any) {
			if (!/^1(3|4|5|6|7|8)\d{9}$/.test(val)) {
				return false
			} else {
				return true
			}
		}

		private checkphone(rule : any, value : any, callback : any) {
			// let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
			if (value == '') {
				callback(new Error('请输入手机号'))
			} else if (!this.isCellPhone(value)) {
				//引入methods中封装的检查手机格式的方法
				callback(new Error('请输入正确的手机号!'))
			} else {
				callback()
			}
		}

		private validID(rule : any, value : any, callback : any) {
			// 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
			let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
			if (value == '') {
				callback(new Error('请输入身份证号码'))
			} else if (reg.test(value)) {
				callback()
			} else {
				callback(new Error('身份证号码不正确'))
			}
		}

		get rules() {
			return {
				username: [
					{
						required: true,
						// 'message': '请输入员工姓名',
						validator: (rule : any, value : string, callback : Function) => {
							if (!value) {
								callback(new Error('请输入预约人姓名'))
							} else {
								// const reg = /^[\u4e00-\u9fa5_a-zA-Z]{1,12}$/
								// if (!reg.test(value)) {
								//   callback(new Error('姓名输入不符，请输入1-12个字符'))
								// } else {
								//   callback()
								// }
								callback()
							}
						},
						trigger: 'blur'
					}
				],

				phoneNum: [{ required: true, validator: this.checkphone, trigger: 'blur' }],
				certificateNumber: [{ required: true, validator: this.validID, trigger: 'blur' }]
			}
		}

		async checkCompanyName(companyName : string) {
			getCompanyByCompanyName(companyName).then((res : any) => {
				if(res.data.code === 1) {
					let companyInfo = `
						企业资质证件号码：${res.data.data.companyCode}<br>
						企业资质类型：${this.getDisplayCompanyQualificationType(res.data.data.companyQualification)}<br>
						公司名称：${res.data.data.companyName}<br>
						工种类型：${this.getDisplayJobType(res.data.data.jobType)}
					`;
					this.$confirm(`是否使用已有数据补充企业信息?<br><br>${companyInfo}`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						dangerouslyUseHTMLString: true, // 允许使用HTML格式
					}).then(() => { // 用户点击了确定按钮
					this.ruleForm.companyCode = res.data.data.companyCode;
						// this.ruleForm.companyLicense = res.data.data.companyLicense;
					this.ruleForm.companyQualification = res.data.data.companyQualification;
					this.ruleForm.companyName = res.data.data.companyName;
					this.ruleForm.jobType = res.data.data.jobType;
						this.$message.success("已补充该公司信息")
					}).catch(() => { // 用户点击了取消按钮

					});
				} else {
					this.$message.error(res.data.msg)
				}
			})
		}

		submitForm(formName : any, st : any) {
			; (this.$refs[formName] as any).validate((valid : any) => {
				if (valid) {
					if (this.actionType === 'add') {
						const params = {
							...this.ruleForm,
						}
						addOrder(params)
							.then((res : any) => {
								if (res.data.code === 1) {
									this.$message.success('预约信息添加成功！')
									if (st) {
										// 清空部分字段，保留其他字段
										this.ruleForm = {
											username: '',
											phoneNum: '',
											gender: '男',
											certificateType: '',
											certificateNumber: '',
											photo: '',
											// 保留以下字段
											companyCode: this.ruleForm.companyCode,
											companyQualification: this.ruleForm.companyQualification,
											companyName: this.ruleForm.companyName,
											companyLicense: this.ruleForm.companyLicense,
											jobType: this.ruleForm.jobType,
										};
									} else {
										this.$router.push({ path: '/category' });
									}
								} else {
									this.$message.error(res.data.msg)
								}
							})
							.catch(() => {
								// this.$message.error('请求出错了：' + err.message)
							})
					} else {//进行修改操作
						const params = {
							...this.ruleForm,
						}
						updateOrder(params).then((res : any) => {
							if(res.data.code === 1) {
								this.$message.success('证件信息修改成功！')
								this.$router.push({ path: '/category' })
							}else {
								this.$message.error(res.data.msg)
							}
						})
					}
				} else {
					return false
				}
			})
		}


    fetchOptions(query) {
      if (query.length >= 4) {
        companyFuzzyQuery(query).then(response => {

          this.options = response.data.data.data.data.map(item => ({
            value: item.creditNo, // 后端返回的数据中企业名称字段为companyName
            label: item.companyName
          }));

        });
      } else {
        this.options = [];
      }
    }

    handleCompanyChange(value) {
      const selectedOption = this.options.find(option => option.value === value);
      if (selectedOption) {
        this.ruleForm.companyName = selectedOption.label;
        this.ruleForm.companyCode = selectedOption.value;
      }
    }
    getDisplayCertificateType(type) {
      const CertificateType = {
        '1': '居民身份证',
        '2': '外国人居住证',
        '3': '港澳台居住证',
        '4': '军官证',
        '5': '驾驶证',
        '6': '港澳居民来往内地通行证',
        '7': '台湾居民来往内地通行证',
        '8': '护照',
        '98': '中国人民武装警察身份证件',
        '99': '港澳台居民居住证'
      };
      return CertificateType[type] || '未知证件类型';
    }
		getDisplayCompanyQualificationType(type) {
			const qualifications = {
				'1': '营业执照',
				'2': '统一社会信用代码证书',
				'3': '卫生许可证',
				'4': '食品安全许可证',
				'5': '食品经营许可证',
				'6': '其他法定有效证件'
			};
			return qualifications[type] || '未知证件类型';
		}

		getDisplayJobType(type) {
			const jobType = {
				'1': '食品',
				'2': '乳制品',
				'3': '医药',
				'4': '美容',
				'5': '服务',
				'6': '饮用水',
				'7': '消毒产品生产',
				'99': '其他'
			};
			return jobType[type] || '未知';
		}
		created() {
			this.actionType = this.$route.query.id ? "update" : "add"
			if(this.$route.query.id) {
				this.title = '修改证件信息'
        // 调用后端 API 获取预约详情
        queryResvDetailById(this.$route.query.id).then(res => {
          if (res.data.code === 1) {
            const data = res.data.data;
            this.ruleForm = res.data.data

          } else {
            console.error('Failed to fetch reservation details:', res.data.message);
          }
        }).catch(error => {
          // 处理网络错误或其他异常
          console.error('An error occurred:', error);
        });
      }
			}
	}
